import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import { Card, Form, Modal } from "react-bootstrap";
import Footer2 from "../components/Footer2";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import axios from "../AxiosInstance";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useAuth } from "../context/auth";
import { BASE_URL } from "../config/BaseUrls";
import toast from "react-hot-toast";
import { LanguageContext } from "../context/LanguageContext";
import { resolveBookImageUrl } from "../utils/urlHelpers";
const initialBooksUser = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Crime",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book2.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book3.png"),
  },

  // Add more book data here as needed
];

const initialBooksUser1 = [
  {
    title: ["We Solve Murders with love", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Duo",
    image: require("../pages/image/book3.png"),
  },

  // Add more book data here as needed
];

const initialBooksRead = [
  {
    title: ["Your own book", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30 ",
    eventType: "Silent Reading",
    image: require("../pages/image/book7.jpg"),
  },
  {
    title: ["Your own book", ""],
    genre: "Crime",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30 ",
    eventType: "Silent Reading",
    image: require("../pages/image/book7.jpg"),
  },
  {
    title: ["Your own book", ""],
    genre: "Crime",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30 ",
    eventType: "Silent Reading",
    image: require("../pages/image/book7.jpg"),
  },

  // Add more book data here as needed
];

const bookspst = [
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book1.png"),
  },
  {
    title: ["Normal People", ""],
    genre: "Fiction",
    eventDate: "WED, Oct 23 - 6:00 pm",
    ageGroup: "Age: 20-30",
    eventType: "Book Club",
    image: require("../pages/image/book2.png"),
  },

  // Add more book data here as needed
];

const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",

  "Germany",
  "France",

  "Brazil",
  "Mexico",

  // Add other countries as needed
];

const settings = {
  // dots: true, // Show dots for navigation
  infinite: true, // Infinite looping
  speed: 500, // Transition speed
  slidesToShow: 3, // Show 3 books at a time
  slidesToScroll: 1, // Move 1 book at a time
  draggable: true, // Allow drag functionality
  swipe: true, // Allow touch swipe
  arrows: false, // Hide default navigation arrows
  responsive: [
    {
      breakpoint: 768, // For screen widths <= 768px
      settings: {
        slidesToShow: 3.5, // Show 2 books at a time
      },
    },
    {
      breakpoint: 450, // For screen widths <= 450px
      settings: {
        slidesToShow: 3, // Show 2.5 books at a time
        centerMode: true, // Center the active slide
        centerPadding: "10px", // Padding around the center item
      },
    },
    {
      breakpoint: 400, // For screen widths <= 450px
      settings: {
        slidesToShow: 2.2, // Show 2.5 books at a time
        centerMode: true, // Center the active slide
        centerPadding: "30px", // Padding around the center item
      },
    },
  ],
};
const DashBoardUser = () => {
  const { lg } = useContext(LanguageContext);
  const [selectedImageLaed, setSelectedImageLaed] = useState(null);
  const fileInputRefLaed = useRef(null);
  const [auth, setAuth] = useAuth();
  const storedAuth = JSON.parse(localStorage.getItem("auth"));
  const isAmbassador = storedAuth?.user?.isAmbassador;
  const userIdd = storedAuth?.user?._id;

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImageLaed = localStorage.getItem("userProfileImage");
    if (storedImageLaed) {
      setSelectedImageLaed(storedImageLaed);
    }
  }, []);

  const handleButtonClickLaed = () => {
    if (fileInputRefLaed.current) {
      fileInputRefLaed.current.click();
    }
  };

  const handleFileChangeLaed = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImageLaed(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("userProfileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  const navigate = useNavigate();
  const [visibleCard, setVisibleCard] = useState(null); // Tracks which card is visible

  const handleEditClick = (index) => {
    setVisibleCard(index); // Show the card corresponding to the clicked index
  };

  const handleCancel = () => {
    setVisibleCard(null); // Hide the card
  };

  const [visibleCard1, setVisibleCard1] = useState(null); // Tracks which card is visible

  const handleEditClick1 = (index) => {
    setVisibleCard1(index); // Show the card corresponding to the clicked index
  };

  const handleCancel1 = () => {
    setVisibleCard1(null); // Hide the card
  };
  const handlegoing1 = () => {
    setVisibleCard1(null); // Hide the card
  };

  const [selectedGoing, setSelectedGoing] = useState(() => {
    // Load saved options from localStorage or set default "Going" for all books
    const savedOptions =
      JSON.parse(localStorage.getItem("selectedOptionsgoingjoinaa101")) || [];
    if (savedOptions.length === 0) {
      // Create default "Going" status for all books
      const defaultOptions = initialBooksUser.map(() => "Going");
      localStorage.setItem(
        "selectedOptionsgoingjoinaa101",
        JSON.stringify(defaultOptions)
      );
      return defaultOptions;
    }
    return savedOptions;
  });

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptionsGoing =
      JSON.parse(localStorage.getItem("selectedOptionsgoingjoinaa101")) || {};

    setSelectedGoing(savedOptionsGoing);
  }, []);
  const [bookSelected, setBookSelected] = useState(null);

  // Save selected option to localStorage
  const handleOptionChangeGoing = (index, value) => {
    const updatedOptionsGoing = { ...selectedGoing, [index]: value };
    setSelectedGoing(updatedOptionsGoing);
    localStorage.setItem(
      "selectedOptionsgoingjoinaa101",
      JSON.stringify(updatedOptionsGoing)
    );
  };
  const handlegoing = () => {
    setVisibleCard(null); // Hide the card
  };

  const [selectedGoingSilent, setSelectedGoingSilent] = useState(() => {
    // Load saved options from localStorage or set default "Going" for all books
    const savedOptions =
      JSON.parse(localStorage.getItem("selectedOptionsgoingsilentjoina101")) ||
      [];
    if (savedOptions.length === 0) {
      // Create default "Going" status for all books
      const defaultOptions = initialBooksRead.map(() => "Going");
      localStorage.setItem(
        "selectedOptionsgoingsilentjoina101",
        JSON.stringify(defaultOptions)
      );
      return defaultOptions;
    }
    return savedOptions;
  });

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptionsGoingSilent =
      JSON.parse(localStorage.getItem("selectedOptionsgoingsilentjoina101")) ||
      {};
    setSelectedGoingSilent(savedOptionsGoingSilent);
  }, []);

  // Save selected option to localStorage
  const handleOptionChangeGoingSilent = (index, value) => {
    const updatedOptionsGoingSilent = {
      ...selectedGoingSilent,
      [index]: value,
    };
    setSelectedGoingSilent(updatedOptionsGoingSilent);
    localStorage.setItem(
      "selectedOptionsgoingsilentjoina101",
      JSON.stringify(updatedOptionsGoingSilent)
    );
  };

  const [visibleCard2, setVisibleCard2] = useState(null); // Tracks which card is visible

  const handleEditClick2 = (index) => {
    setVisibleCard2(index); // Show the card corresponding to the clicked index
  };

  const handleCancel2 = () => {
    setVisibleCard2(null); // Hide the card
  };
  const handlegoing2 = () => {
    setVisibleCard2(null); // Hide the card
  };

  const [selectedGoing2, setSelectedGoing2] = useState(() => {
    // Load saved options from localStorage or set default "Going" for all books
    const savedOptions =
      JSON.parse(localStorage.getItem("selectedOptionsgoingjoin2101")) || [];
    if (savedOptions.length === 0) {
      // Create default "Going" status for all books
      const defaultOptions = initialBooksUser1.map(() => "Going");
      localStorage.setItem(
        "selectedOptionsgoingjoin2101",
        JSON.stringify(defaultOptions)
      );
      return defaultOptions;
    }
    return savedOptions;
  });

  // Load saved options from localStorage
  useEffect(() => {
    const savedOptionsGoing2 =
      JSON.parse(localStorage.getItem("selectedOptionsgoingjoin2101")) || {};
    setSelectedGoing2(savedOptionsGoing2);
  }, []);

  // Save selected option to localStorage
  const handleOptionChangeGoing2 = (index, value) => {
    const updatedOptionsGoing2 = { ...selectedGoing2, [index]: value };
    setSelectedGoing2(updatedOptionsGoing2);
    localStorage.setItem(
      "selectedOptionsgoingjoin2101",
      JSON.stringify(updatedOptionsGoing2)
    );
  };

  const [books, setBooks] = useState(() => {
    const savedBooks = localStorage.getItem("booksRemoveUserJoin4101");
    return savedBooks ? JSON.parse(savedBooks) : initialBooksUser;
  });

  const handleNotGoing1 = (indexToRemove) => {
    const updatedBooks = books.filter((_, index) => index !== indexToRemove);

    // Update state and save to localStorage
    setBooks(updatedBooks);
    setVisibleCard1(null);
    handleShowW(false);

    localStorage.setItem(
      "booksRemoveUserJoin4101",
      JSON.stringify(updatedBooks)
    );
  };

  useEffect(() => {
    // Save books to localStorage whenever they change
    localStorage.setItem("books", JSON.stringify(books));
  }, [books]);

  // Second card
  const [booksread, setBooksread] = useState(() => {
    const savedBooks = localStorage.getItem("booksRemoveUserJoin4101");
    return savedBooks ? JSON.parse(savedBooks) : initialBooksRead;
  });

  // const handleNotGoing = (indexToRemove) => {
  //   const updatedBooks = booksread.filter(
  //     (_, index) => index !== indexToRemove
  //   );

  //   // Update state and save to localStorage
  //   setBooksread(updatedBooks);
  //   setVisibleCard(null);
  //   handleShowW1(false);

  //   localStorage.setItem("booksRemoveUserRead", JSON.stringify(updatedBooks));
  // };

  const [wShow, setWShow] = useState(null); // For signup modal

  const handleCloseW = () => {
    setWShow(false);
  };
  const handleShowW = (index) => {
    setWShow(index); // Open  modal
    // setVisibleCard(null);
  };

  useEffect(() => {
    // Save books to localStorage whenever they change
    localStorage.setItem("booksread", JSON.stringify(booksread));
  }, [booksread]);

  // Third

  const [books1, setBooks1] = useState(() => {
    const savedBooks = localStorage.getItem("booksRemoveUserJoinBook12101");
    return savedBooks ? JSON.parse(savedBooks) : initialBooksUser1;
  });

  const handleNotGoing2 = (indexToRemove) => {
    const updatedBooks = books1.filter((_, index) => index !== indexToRemove);

    // Update state and save to localStorage
    setBooks1(updatedBooks);
    setVisibleCard2(null);
    handleShowW2(false);
    localStorage.setItem(
      "booksRemoveUserJoinBook12101",
      JSON.stringify(updatedBooks)
    );
  };

  useEffect(() => {
    // Save books to localStorage whenever they change
    localStorage.setItem("books1", JSON.stringify(books1));
  }, [books1]);

  const [wShow1, setWShow1] = useState(false); // For signup modal

  const handleCloseW1 = () => {
    setWShow1(false);
  };
  const handleShowW1 = (index) => {
    setWShow1(index); // Open  modal
    setVisibleCard(null);
  };

  const [wShow2, setWShow2] = useState(false); // For signup modal
  const [wShowCanc, setWShowCanc] = useState(false);
  const handleCloseCanc = () => {
    setWShowCanc(false);
  };
  const handleCloseW2 = () => {
    setWShow2(false);
  };
  const handleShowW2 = (index) => {
    setWShow2(index); // Open  modal
    setVisibleCard2(null);
  };

  const handleEventTypeClick = (eventType, eventId) => {
    const eventRoutes = {
      "Book Duo": "/meetorganizer",
      "Book Club": "/groupevent",
      "Silent Reading": "/silentreadingabout",
    };

    const route = eventRoutes[eventType];
    if (route) {
      navigate(`${route}?bookid=${eventId}`);
    } else {
      console.error("No route defined for this event type:", eventType);
    }
  };

  const user = auth?.user; // ✅ Prevent undefined errors

  // FAtch User Details

  const userId = auth?.user?._id;

  const [users, setUsers] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  const [joinedBook, setJoinedBook] = useState([]);

  useEffect(() => {
    const fetchJoinedBookDetails = async () => {
      const eventDataNew = JSON.parse(localStorage.getItem("eventDataNew"));
      if (!eventDataNew) return;

      try {
        const res = await axios.get(
          `api/v1/books/get-book-by-id/${eventDataNew.eventId}`
        );
        setJoinedBook(res.data);
      } catch (error) {
        console.error("Failed to fetch joined book", error);
      }
    };

    fetchJoinedBookDetails();
  }, []);

  console.log("joinedBook:", joinedBook);
  // console.log("joinedBookimage:", book.bookImage);

  const [joinedBooks, setJoinedBooks] = useState([]);

  useEffect(() => {
    const fetchJoinedBooks = async () => {
      // Assuming login user data is stored

      try {
        const res = await axios.get(`api/v1/books/user-joined-books/${userId}`);
        setJoinedBooks(Array.isArray(res.data) ? res.data : []); // ✅ ensures it's always an array
      } catch (err) {
        console.error("Error fetching joined books", err);
      }
    };

    fetchJoinedBooks();
  }, [userId]);

  const token = auth?.token; // <-- Your actual JWT

  const handleNotGoing = async (bookId) => {
    console.log("Calling API to remove user from book:", bookId);

    try {
      const res = await await axios.post(
        `/api/v1/books/notgoing/${bookId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Replace with actual token
          },
        }
      );
      console.log("API Response:", res.data);

      // Remove from frontend list
      setJoinedBooks((prev) =>
        Array.isArray(prev) ? prev.filter((book) => book._id !== bookId) : []
      );
      toast.success("Successfully removed from attendees"); // to confirm visually
    } catch (error) {
      console.error("Error removing user from book:", error);
      alert("API call failed — check console for error");
    }
  };

  const bookClubBooks = joinedBooks.filter(
    (book) =>
      book.name?.trim().toLowerCase() === "book club" &&
      book.attendees?.some((attendee) => attendee._id === userIdd)
  );

  const booksilentBooks = joinedBooks.filter(
    (book) =>
      book.name?.trim().toLowerCase() === "silent reading" &&
      book.attendees?.some((attendee) => attendee._id === userIdd)
  );

  const bookDuoBooks = joinedBooks.filter((book) => book.name === "Book Duo");

  const [latestBooks, setLatestBooks] = useState([]);

  useEffect(() => {
    const fetchLatestBooks = async () => {
      try {
        const response = await axios.get("api/v1/books/getlastestbooks");
        setLatestBooks(response.data.data);
      } catch (error) {
        console.error("Error fetching latest books:", error);
      }
    };

    fetchLatestBooks();
  }, []);

  const filteredBooks = isAmbassador
    ? latestBooks.filter(
        (book) =>
          book.name === "Book Duo" &&
          book.attendees.some((att) => att._id === userIdd)
      )
    : joinedBooks.filter(
        (book) =>
          book.name === "Book Duo" &&
          book.attendees.some((att) => att._id === userIdd)
      );

  return (
    <>
      <div className="leaddashheader">
        <Header3 />
      </div>

      <div className="alincenterawidth">
        <div
          className="highyauto"
          style={{
            backgroundColor: "#F2F2F2",
            height: "185px",
            alignItems: "center",
          }}
        >
          <div
            className="d-md-flex  justzomag11   mlmrleading gap-xl-5 gap-4 "
            style={{ paddingTop: "30px" }}
          >
            <div className="textsmctrlead   ">
              {/* Header */}
              <div className="d-sm-flex  gap-2 gap-md-3 ">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRefLaed}
                  style={{ display: "none" }} // Hide the input
                  onChange={handleFileChangeLaed} // Handle file change
                />
                <img
                  src={
                    users?.profileImage
                      ? BASE_URL + "/uploads/" + users.profileImage
                      : require("../pages/image/addphotoicon.png")
                  } // Show user-selected image or default image
                  alt="Profile"
                  className="rounded-circle widimg "
                  width="105px"
                  height="105px"
                  style={{ width: "105px", height: "105px" }} // Set dimensions as needed
                  // onClick={handleButtonClickLaed} // Allow clicking on the image to upload a new one
                />
                <div className="text-center text-sm-start d-flex align-items-center flex-column justify-content-center">
                  <div
                    className=" mt-2 fw-bold fs-22 ftzpual text-dark "
                    style={{ lineHeight: "33.6px" }}
                  >
                    {user?.name}
                  </div>
                  {user?.isAmbassador && (
                    <>
                      <div
                        className="fw-normal ftzpual fs-22"
                        style={{ color: "#DF8244" }}
                      >
                        Ambassador
                      </div>
                      <div
                        className="fw600 fs-18 ftzpual  ftzgern"
                        style={{ color: "#2A2A2A" }}
                      >
                        {/* Level  */}
                        {lg?.level}1
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className=" mt-lg-4 mt-2 pt-sm-2 mx-lg-5 mlmreditbrns justify-content-center  d-flex flex-wrap gap-sm-4 gap-2">
              <button
                className="text-white rounded-1 fw-bold fs-18 btnedit2 ftzgern border-0 text-center"
                style={{
                  width: "153px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                }}
                onClick={() => navigate("/profile")}
              >
                {/* Edit Profile */}
                {lg?.editprf}
              </button>

              {/* OLD CODE - Future use: Ambassador conditional rendering */}
              {/* {user?.isAmbassador && (
                <>
                  <button
                    className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                    style={{
                      width: "180px",
                      height: "53px",
                      backgroundColor: "#34C3C9",
                      fontSize: "18px",
                      lineHeight: "18px",
                    }}
                    // onClick={handleShow} // Trigger modal on click
                    onClick={() => navigate("/booksdetails")}
                  >
                    {lg?.cbclub}
                  </button>
                  <button
                    className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                    style={{
                      width: "180px",
                      height: "53px",
                      backgroundColor: "#34C3C9",
                      fontSize: "18px",
                      lineHeight: "18px",
                    }}
                    onClick={() => navigate("./silentreading")} // Trigger modal on click
                  >
                    {lg?.cbsil}
                  </button>
                </>
              )} */}
              {/* NEW CODE: All users can create events */}
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                // onClick={handleShow} // Trigger modal on click
                onClick={() => navigate("/booksdetails")}
              >
                {/* CREATE <br /> BOOK CLUB */}
                {/* Create <br /> Book Club */}
                {lg?.cbclub}
              </button>
              <button
                className="text-white  rounded-1 fw-bold btneditmeet ftzgern border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("./silentreading")} // Trigger modal on click
              >
                {/* CREATE <br /> SILENT READING */}
                {/* Create <br /> Silent Reading */}
                {lg?.cbsil}
              </button>
              <button
                className="text-white rounded-1 fw-bold btneditmeet ftzgern  border-0 text-center"
                style={{
                  width: "180px",
                  height: "53px",
                  backgroundColor: "#34C3C9",
                  fontSize: "18px",
                  lineHeight: "18px",
                }}
                onClick={() => navigate("/createmeetup")}
              >
                {/* CREATE <br /> BOOK DUO */}
                {/* Create
                <br /> Book Duo */}
                {lg?.cbduo}
              </button>
            </div>
          </div>
        </div>

        <div
          className="d-flex leadhight  justzomag11  leadflex leadjoin gap-lg-0 gap-1 w-100 text-uppercase"
          style={{ backgroundColor: "#A6A6A6", height: "59px" }}
        >
          <div
            className="px-lg-5 px-md-4 px-3 pt-3    ftzgern text-dark fw-bold fs-18 text-center  "
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/leading")}
          >
            {lg?.leadin}
          </div>{" "}
          <div
            className="px-lg-5 px-md-4 px-3 py-3   bg-white ftzgern text-dark fw-bold fs-18 text-center  "
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboarduser")}
          >
            {/* I’M JOINING */}
            {lg?.joining}
          </div>
          <div
            className="px-md-3 px-2 py-3  ftzgern text-dark fw-bold fs-18 text-center"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/booksandreviewsuser")}
          >
            {/* Books & reviews */}
            {lg?.bandrew}
          </div>
          {user?.isAmbassador && (
            <div
              className="px-md-3 px-sm-2 pt-3 ftzgern text-dark fw-bold fs-18 text-center"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/loyalty")}
            >
              {/* Loyalty programme */}
              {lg?.loyprog}
            </div>
          )}
        </div>

        <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
          {/* Upcoming Book Clubs */}
          {lg?.upcomclub}
        </div>

        <div className="d-sm-flex d-none justzomag11 flex-wrap jucfyy paddleft mx-5 gap-3 mt-3">
          {bookClubBooks?.length === 0 && "No events to be shown."}
          {bookClubBooks.map((book, index) => {
            let spotsLeft =
              Number(book?.maxAttendee) - Number(book?.attendees?.length || 0);

            return (
              <Card
                key={book._id}
                className="border-0 align-items-center"
                style={{ width: "" }}
              >
                <div className="d-sm-flex gap-2">
                  {book.image ? (
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <Card.Img
                        className="imgsize157"
                        variant="top"
                        src={resolveBookImageUrl(book.image)}
                        style={{
                          width: "119px",
                          height: "170px",
                          objectFit: "contain",
                          cursor: "pointer",
                          opacity:
                            book?.name == "Book Club"
                              ? spotsLeft === 0
                                ? 0.3
                                : 1
                              : 1,
                        }}
                        onClick={() => {
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                      {spotsLeft === 0 && book?.name == "Book Club" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%) rotate(301deg)",
                            color: "red",
                            fontSize: "32px",
                            fontWeight: "bold",
                            border: "2px solid red",
                            padding: "5px 15px",
                            textTransform: "uppercase",
                            backgroundColor: "rgba(255,255,255,0.6)",
                            pointerEvents: "none",
                          }}
                        >
                          FULL
                        </div>
                      )}
                    </div>
                  ) : book.name === "Silent Reading" ? (
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <Card.Img
                        className="imgsize157"
                        variant="top"
                        src={require("./image/book7.jpg")}
                        style={{
                          width: "119px",
                          height: "170px",
                          objectFit: "contain",
                          cursor: "pointer",
                          opacity:
                            book?.name == "Silent Reading"
                              ? spotsLeft === 0
                                ? 0.3
                                : 1
                              : 1,
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            aboutBook: book.aboutBook,

                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            aboutBook: book.aboutBook,

                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            link: book.link || "",
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />{" "}
                      {spotsLeft === 0 && book?.name == "Silent Reading" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%) rotate(301deg)",
                            color: "red",
                            fontSize: "32px",
                            fontWeight: "bold",
                            border: "2px solid red",
                            padding: "5px 15px",
                            textTransform: "uppercase",
                            backgroundColor: "rgba(255,255,255,0.6)",
                            pointerEvents: "none",
                          }}
                        >
                          FULL
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "119px",
                        height: "170px",
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#777",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleEventTypeClick(book.name, book._id);
                      }}
                    >
                      No Image
                    </div>
                  )}
                  <Card.Body className="mt-0 pt-0 ">
                    <Card.Title
                      className=" w-100 text-black  fw-bold ftztitle "
                      style={{
                        // color: "#6D6D6D",
                        fontSize: "20px",
                        maxWidth: "210px",

                        lineHeight:
                          book.title[0] === "Before the coffee"
                            ? "20px"
                            : "25px", // Conditional line height

                        marginBottom:
                          book.title[0] === "We Solve Murders with love"
                            ? "5px"
                            : "28px", // Conditional line height
                      }}
                    >
                      {/* {book?.title ? book.title.slice(0, 14) : "Normal People"} */}
                      {book?.name === "Silent Reading"
                        ? "Your Own Book"
                        : book?.title?.slice(0, 14) || "Normal People"}
                    </Card.Title>
                    <Card.Text
                      className=" w-100 ftzgern fw-bold  m-0"
                      style={{
                        // color: "#383838",
                        color: "gray",
                        fontSize: "16px",
                        lineHeight: "25px",
                        maxWidth: "215px",
                      }}
                    >
                      {
                        book?.name == "Book Duo"
                          ? "TBD"
                          : book?.dateInfo?.dayName +
                            ",  " +
                            book?.dateInfo?.day +
                            " " +
                            book?.dateInfo?.month +
                            " " +
                            book?.dateInfo?.year

                        //             +

                        // " " +
                        // book?.timeTrack?.seconds
                      }
                    </Card.Text>
                    <Card.Title
                      className=" ftzgern fw600 fs-6 m-0"
                      style={{
                        color:
                          book.name === "Book Duo"
                            ? "#C55A11"
                            : book.name === "Book Club"
                            ? "#548235"
                            : book.name === "Silent Reading"
                            ? "#0070C0" // Blue for "Silent Reading"
                            : "#000000", // Default color for other event types

                        lineHeight: "25px",
                      }}
                    >
                      {book?.name}
                    </Card.Title>
                    <Card.Title
                      className=" ftzgern fw600 fs-6 m-0"
                      style={{
                        color: "#000000",

                        lineHeight: "25px",
                      }}
                    >
                      Age: {book?.age}
                    </Card.Title>

                    <div key={book._id}>
                      <button
                        className="rounded-1 mt-1 py-1  editbtitn fw600 ftzgern fs-6 text-center text-dark"
                        style={{
                          border: "1px solid #383838",
                          backgroundColor: "#F2F2F2",
                          width: "120px",
                          height: "auto",
                        }}
                        onClick={() => {
                          console.log("Clicked Not Going for", book._id);
                          setWShowCanc(true); // Show the cancel modal
                          setBookSelected(book._id); // Store the book ID for later use
                        }}
                      >
                        {/* Edit */}
                        {lg?.canc}
                      </button>

                      {/* Conditional Content */}
                      <div
                        key={index}
                        className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                          visibleCard === index ? "" : "d-none"
                        }`}
                        style={{
                          border: "1px solid #C1C1C1",
                          width: "240px",
                          height: "100px",
                        }}
                      >
                        <div>
                          <Form>
                            {["radio"].map((type) => (
                              <div
                                key={`inline-${type}`}
                                className="fw-normal flxder   pt-1"
                                style={{ fontSize: "14px" }}
                              >
                                <Form.Check
                                  inline
                                  label={lg?.going}
                                  name={`group-${index}`}
                                  type={type}
                                  id={`inline-${type}-1-${index}`}
                                  onClick={handlegoing}
                                  checked={selectedGoing[index] === "Going"}
                                  onChange={() =>
                                    handleOptionChangeGoing(index, "Going")
                                  }
                                />
                                <Form.Check
                                  inline
                                  label={lg?.ngoing}
                                  name={`group-${index}`}
                                  type={type}
                                  id={`inline-${type}-2-${index}`}
                                  onClick={() => handleShowW(index)}
                                />
                              </div>
                            ))}
                          </Form>

                          {wShow === index && (
                            <Modal
                              show={true}
                              onHide={handleCloseW}
                              centered
                              className="custom-gropmodelwel roundedambdmodl"
                              backdrop={true}
                            >
                              <Modal.Header className=" border-0">
                                <img
                                  className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                  src={require("../components/image/close.png")}
                                  alt="logo"
                                  onClick={handleCloseW}
                                />
                              </Modal.Header>
                              <Modal.Title className="mx-5 "></Modal.Title>
                              <Modal.Body className="mx-4 mt-sm-2">
                                <div
                                  className=" fw-bold   text-center  w-100 ftzcopy   "
                                  style={{ fontSize: "21px" }}
                                >
                                  Are you sure that you no longer want to attend
                                  this event? The event will be removed from
                                  your dashboard.
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                  <button
                                    className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                    style={{
                                      width: "150px",
                                      height: "44px",
                                      backgroundColor: "#62C0C7",
                                    }}
                                    // onClick={() => handleNotGoing(book._id)}
                                    onClick={() => {
                                      console.log(
                                        "Clicked Not Going for",
                                        book._id
                                      );
                                      handleNotGoing(book._id);
                                    }}
                                  >
                                    {/* Not going */}
                                    {lg?.ngoing}
                                  </button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          )}
                        </div>
                        {/* )} */}
                        <div
                          className="fw600 text-decoration-underline"
                          style={{ fontSize: "13px", cursor: "pointer" }}
                          onClick={handleCancel}
                        >
                          {/* Cancel */}
                          {lg?.cancel}
                        </div>
                      </div>
                    </div>

                    {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                  </Card.Body>
                </div>
              </Card>
            );
          })}
        </div>

        {/* coursol */}
        <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
          {bookClubBooks?.length === 0 && "No events to be shown."}
          <Slider {...settings}>
            {bookClubBooks.map((book, index) => {
              let spotsLeft =
                Number(book?.maxAttendee) -
                Number(book?.attendees?.length || 0);

              return (
                <div key={book._id} className="d-flex justify-content-center">
                  <Card
                    key={book._id}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <div className="d-sm-flex gap-2">
                      {book.image ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="wrw"
                            variant="top"
                            src={BASE_URL + book.image}
                            style={{
                              width: "115px",
                              height: "150px",
                              objectFit: "contain",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Book Club"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                aboutBook: book.aboutBook,

                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                aboutBook: book.aboutBook,

                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                link: book.link || "",
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 && book?.name == "Book Club" && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform:
                                  "translate(-50%, -50%) rotate(301deg)",
                                color: "red",
                                fontSize: "32px",
                                fontWeight: "bold",
                                border: "2px solid red",
                                padding: "5px 15px",
                                textTransform: "uppercase",
                                backgroundColor: "rgba(255,255,255,0.6)",
                                pointerEvents: "none",
                              }}
                            >
                              FULL
                            </div>
                          )}
                        </div>
                      ) : book.name === "Silent Reading" ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="ww"
                            variant="top"
                            src={require("./image/book7.jpg")}
                            style={{
                              width: "115px",
                              height: "150px",
                              objectFit: "contain",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Silent Reading"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                aboutBook: book.aboutBook,

                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                aboutBook: book.aboutBook,

                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                link: book.link || "",
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 &&
                            book?.name == "Silent Reading" && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform:
                                    "translate(-50%, -50%) rotate(301deg)",
                                  color: "red",
                                  fontSize: "32px",
                                  fontWeight: "bold",
                                  border: "2px solid red",
                                  padding: "5px 15px",
                                  textTransform: "uppercase",
                                  backgroundColor: "rgba(255,255,255,0.6)",
                                  pointerEvents: "none",
                                }}
                              >
                                FULL
                              </div>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "115px",
                            height: "150px",
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#777",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              aboutBook: book.aboutBook,

                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              aboutBook: book.aboutBook,

                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              link: book.link || "",
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              LangLat: book?.location,
                              // type:
                              //   book.type.toLowerCase() === "on-line"
                              //     ? "Book Duo"
                              //     : "Book Club", // ✅ Condition Added
                            };
                            console.log("✅ Event Data:", eventData);
                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book.name, book._id);
                          }}
                        >
                          No Image
                        </div>
                      )}
                      <Card.Body className="mt-0 p-0 text-center">
                        <Card.Title
                          className=" w-100 text-blakkck  fw-bold ftztfitle "
                          style={{
                            // color: "#6D6D6D",
                            fontSize: "15px",
                            maxWidth: "115px",

                            lineHeight:
                              book.title[0] === "Before the coffee"
                                ? "20px"
                                : "25px", // Conditional line height

                            marginBottom:
                              book.title[0] === "We Solve Murders with love"
                                ? "5px"
                                : "5px", // Conditional line height
                          }}
                        >
                          {book?.name === "Silent Reading"
                            ? "Your Own Book"
                            : book?.title?.slice(0, 10) || "Normal People"}
                        </Card.Title>
                        <Card.Text
                          className=" w-100 ftzgegrn fw-bold  m-0"
                          style={{
                            // color: "#383838",
                            color: "gray",
                            fontSize: "14px",
                            lineHeight: "20px",
                            maxWidth: "130px",
                          }}
                        >
                          {book?.name == "Book Duo"
                            ? "TBD"
                            : book?.dateInfo?.dayName +
                              ",  " +
                              book?.dateInfo?.day +
                              " " +
                              book?.dateInfo?.month +
                              " " +
                              book?.dateInfo?.year}
                        </Card.Text>
                        <Card.Title
                          className=" ftzgegrn fw600  m-0"
                          style={{
                            fontSize: "15px",
                            color:
                              book.name === "Book Duo"
                                ? "#C55A11"
                                : book.name === "Book Club"
                                ? "#548235"
                                : book.name === "Silent Reading"
                                ? "#0070C0" // Blue for "Silent Reading"
                                : "#000000", // Default color for other event types

                            lineHeight: "25px",
                          }}
                        >
                          {book?.name}
                        </Card.Title>
                        <Card.Title
                          className=" ftzggern fw600  m-0"
                          style={{
                            fontSize: "15px",

                            lineHeight: "25px",
                          }}
                        >
                          Age {book.age}
                        </Card.Title>
                        {/* <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div key={book._id}>
                          <button
                            className="rounded-1 mt-2 py-1 ediftbtitn fw600 ftzgern fs-6 text-center text-dark"
                            style={{
                              border: "1px solid #383838",
                              backgroundColor: "#F2F2F2",
                              width: "80px",
                              height: "auto",
                            }}
                            onClick={() => handleEditClick(book._id)}
                          >
                            {/* Edit */}
                            {lg?.canc}
                          </button>

                          {/* <div
                    key={index}
                    className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                      visibleCard === index ? "" : "d-none"
                    }`}
                    style={{
                      border: "1px solid #C1C1C1",
                      width: "277px",
                      height: "130px",
                    }}
                  >
                   
                    {index === 1 ? (
                      <div>
                        <div className="fw-bold fs-6">IF ORGANIZED BY USER</div>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}-second`}
                              className="fw-normal flxder"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="confirm"
                                name={`group-second`}
                                type={type}
                                id={`inline-${type}-1-second`}
                              />
                              <Form.Check
                                inline
                                label="Reject"
                                name={`group-second`}
                                type={type}
                                id={`inline-${type}-2-second`}
                              />
                              <Form.Check
                                inline
                                label="Edit"
                                name={`group-second`}
                                type={type}
                                id={`inline-${type}-3-second`}
                              />
                            </div>
                          ))}
                        </Form>
                      </div>
                    ) : (
                      <div>
                        <div className="fw-bold fs-6">
                          IF ORGANIZED BY OTHER USER
                        </div>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-1-${index}`}
                              />
                              <Form.Check
                                inline
                                label="not going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-2-${index}`}
                              />
                            </div>
                          ))}
                        </Form>
                      </div>
                    )}
                    <div
                      className="fw600  text-decoration-underline"
                      style={{ fontSize: "13px" }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </div>
                  </div> */}

                          {/* Conditional Content */}
                          <div
                            key={index}
                            className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                              visibleCard1 === index ? "" : "d-none"
                            }`}
                            style={{
                              border: "1px solid #C1C1C1",
                              width: "240px",
                              height: "100px",
                            }}
                          >
                            {/* {index === 1 ? (
                     
                      <div>
                       
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder   pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-1-${index}`}
                                onClick={handlegoing1}
                                checked={selectedGoing[index] === "Going"}
                                onChange={() =>
                                  handleOptionChangeGoing(index, "Going")
                                }
                              />
                              <Form.Check
                                inline
                                label="not going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-2-${index}`}
                                onChange={() => handleNotGoing1(index)}
                              />
                            </div>
                          ))}
                        </Form>
                      </div>
                    ) : ( */}
                            <div>
                              {/* <div className="fw-bold fs-6">
                          IF ORGANIZED BY OTHER USER
                        </div> */}
                              <Form>
                                {["radio"].map((type) => (
                                  <div
                                    key={`inline-${type}`}
                                    className="fw-normal flxder   pt-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <Form.Check
                                      inline
                                      label={lg?.going}
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-1-${index}`}
                                      onClick={handlegoing1}
                                      checked={selectedGoing[index] === "Going"}
                                      onChange={() =>
                                        handleOptionChangeGoing(index, "Going")
                                      }
                                    />
                                    <Form.Check
                                      inline
                                      label={lg?.ngoing}
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-2-${index}`}
                                      onClick={() => handleShowW(index)}
                                    />
                                  </div>
                                ))}
                              </Form>

                              {wShow === index && (
                                <Modal
                                  show={true}
                                  onHide={handleCloseW}
                                  centered
                                  className="custom-gropmodelwel roundedambdmodl"
                                  backdrop={true}
                                >
                                  <Modal.Header className=" border-0">
                                    <img
                                      className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                      src={require("../components/image/close.png")}
                                      alt="logo"
                                      onClick={handleCloseW}
                                    />
                                  </Modal.Header>
                                  <Modal.Title className="mx-5 "></Modal.Title>
                                  <Modal.Body className="mx-4 mt-sm-2">
                                    <div
                                      className=" fw-bold   text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      Are you sure that you no longer want to
                                      attend this event? The event will be
                                      removed from your dashboard.
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                        style={{
                                          width: "150px",
                                          height: "44px",
                                          backgroundColor: "#62C0C7",
                                        }}
                                        onClick={() => handleNotGoing1(index)}
                                      >
                                        {/* Not going */}
                                        {lg?.ngoing}
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              )}
                            </div>
                            {/* )} */}
                            <div
                              className="fw600 text-decoration-underline"
                              style={{ fontSize: "13px", cursor: "pointer" }}
                              onClick={handleCancel1}
                            >
                              {/* Cancel */}
                              {lg?.cancel}
                            </div>
                          </div>
                        </div>

                        {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                      </Card.Body>
                    </div>
                  </Card>
                </div>
              );
            })}
          </Slider>
        </div>

        <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
          {/* Upcoming Silent Readings */}
          {lg?.upcomsil}
        </div>

        <div className="d-sm-flex d-none flex-wrap paddleft  justzomag11  jucfyy  mx-5 gap-3 mt-3">
          {booksilentBooks?.length === 0 && "No events to be shown."}
          {booksilentBooks.map((book, index) => {
            let spotsLeft =
              Number(book?.maxAttendee) - Number(book?.attendees?.length || 0);

            return (
              <Card
                key={book._id}
                className="border-0 align-items-center"
                style={{ width: "" }}
              >
                <div className="d-sm-flex gap-2">
                  {book.image ? (
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <Card.Img
                        className="imgsize157"
                        variant="top"
                        src={resolveBookImageUrl(book.image)}
                        style={{
                          width: "119px",
                          height: "170px",
                          objectFit: "contain",
                          cursor: "pointer",
                          opacity:
                            book?.name == "Book Club"
                              ? spotsLeft === 0
                                ? 0.3
                                : 1
                              : 1,
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            aboutBook: book.aboutBook,

                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                      {spotsLeft === 0 && book?.name == "Book Club" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%) rotate(301deg)",
                            color: "red",
                            fontSize: "32px",
                            fontWeight: "bold",
                            border: "2px solid red",
                            padding: "5px 15px",
                            textTransform: "uppercase",
                            backgroundColor: "rgba(255,255,255,0.6)",
                            pointerEvents: "none",
                          }}
                        >
                          FULL
                        </div>
                      )}
                    </div>
                  ) : book.name === "Silent Reading" ? (
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      <Card.Img
                        className="imgsize157"
                        variant="top"
                        src={require("./image/book7.jpg")}
                        style={{
                          width: "119px",
                          height: "170px",
                          objectFit: "contain",
                          cursor: "pointer",
                          opacity:
                            book?.name == "Silent Reading"
                              ? spotsLeft === 0
                                ? 0.3
                                : 1
                              : 1,
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            aboutBook: book.aboutBook,

                            LangLat: book?.location,
                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                      {spotsLeft === 0 && book?.name == "Silent Reading" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%) rotate(301deg)",
                            color: "red",
                            fontSize: "32px",
                            fontWeight: "bold",
                            border: "2px solid red",
                            padding: "5px 15px",
                            textTransform: "uppercase",
                            backgroundColor: "rgba(255,255,255,0.6)",
                            pointerEvents: "none",
                          }}
                        >
                          FULL
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "119px",
                        height: "170px",
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#777",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const eventData = {
                          type: book.name,
                          location: book.city || "", // Use dynamic location
                          link: book.link || "",
                          title: book.title,
                          image: book.image,
                          author: book.author,
                          pages: book.pageNumber,
                          genre: book.genre,
                          age: book.age,
                          city: book.city,
                          language: book.language,
                          gender: book.gender,
                          detail: book.description,
                          eventType: book.type,
                          createdAt: book?.dateInfo,
                          time: book?.timeTrack,
                          userId: book?.userId,
                          meetingLink: book?.meetingLink,
                          eventId: book._id,
                          attendees: book?.attendees,
                          LangLat: book?.location,
                          aboutBook: book.aboutBook,

                          // type:
                          //   book.type.toLowerCase() === "on-line"
                          //     ? "Book Duo"
                          //     : "Book Club", // ✅ Condition Added
                        };
                        console.log("✅ Event Data:", eventData);
                        localStorage.setItem(
                          "eventDataNew",
                          JSON.stringify(eventData)
                        );
                        handleEventTypeClick(book.name, book._id);
                      }}
                    >
                      No Image
                    </div>
                  )}
                  <Card.Body className="mt-0 pt-0 ">
                    <Card.Title
                      className=" w-100 text-black  fw-bold ftztitle "
                      style={{
                        // color: "#6D6D6D",
                        fontSize: "20px",
                        maxWidth: "210px",

                        lineHeight:
                          book.title[0] === "Before the coffee"
                            ? "20px"
                            : "25px", // Conditional line height

                        marginBottom:
                          book.title[0] === "We Solve Murders with love"
                            ? "5px"
                            : "28px", // Conditional line height
                      }}
                    >
                      {/* {book?.title ? book.title.slice(0, 14) : "Normal People"} */}
                      {book?.name === "Silent Reading"
                        ? "Your Own Book"
                        : book?.title?.slice(0, 14) || "Normal People"}
                    </Card.Title>
                    <Card.Text
                      className=" w-100 ftzgern fw-bold  m-0"
                      style={{
                        // color: "#383838",
                        color: "gray",
                        fontSize: "16px",
                        lineHeight: "25px",
                        maxWidth: "215px",
                      }}
                    >
                      {book?.name == "Book Duo"
                        ? "TBD"
                        : book?.dateInfo?.dayName +
                          ",  " +
                          book?.dateInfo?.day +
                          " " +
                          book?.dateInfo?.month +
                          " " +
                          book?.dateInfo?.year}
                    </Card.Text>
                    <Card.Title
                      className=" ftzgern fw600 fs-6 m-0"
                      style={{
                        color:
                          book.name === "Book Duo"
                            ? "#C55A11"
                            : book.name === "Book Club"
                            ? "#548235"
                            : book.name === "Silent Reading"
                            ? "#0070C0" // Blue for "Silent Reading"
                            : "#000000", // Default color for other event types

                        lineHeight: "25px",
                      }}
                    >
                      {book?.name}
                    </Card.Title>
                    <Card.Title
                      className=" ftzgern fw600 fs-6 m-0"
                      style={{
                        color: "#000000",

                        lineHeight: "25px",
                      }}
                    >
                      Age: {book?.age}
                    </Card.Title>
                    {/* <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                    <div key={index}>
                      <button
                        className="rounded-1 mt-1 py-1 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                        style={{
                          border: "1px solid #383838",
                          backgroundColor: "#F2F2F2",
                          width: "120px",
                          height: "auto",
                        }}
                        onClick={() => {
                          console.log("Clicked Not Going for", book._id);
                          setWShowCanc(true); // Show the cancel modal
                          setBookSelected(book._id); // Store the book ID for later use
                        }}
                      >
                        {/* Edit */}
                        {lg?.canc}
                      </button>

                      {/* Conditional Content */}
                      <div
                        key={index}
                        className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                          visibleCard1 === index ? "" : "d-none"
                        }`}
                        style={{
                          border: "1px solid #C1C1C1",
                          width: "240px",
                          height: "100px",
                        }}
                      >
                        <div>
                          <Form>
                            {["radio"].map((type) => (
                              <div
                                key={`inline-${type}`}
                                className="fw-normal flxder   pt-1"
                                style={{ fontSize: "14px" }}
                              >
                                <Form.Check
                                  inline
                                  label={lg?.going}
                                  name={`group-${index}`}
                                  type={type}
                                  id={`inline-${type}-1-${index}`}
                                  onClick={handlegoing1}
                                  checked={selectedGoing[index] === "Going"}
                                  onChange={() =>
                                    handleOptionChangeGoing(index, "Going")
                                  }
                                />
                                <Form.Check
                                  inline
                                  label={lg?.ngoing}
                                  name={`group-${index}`}
                                  type={type}
                                  id={`inline-${type}-2-${index}`}
                                  onClick={() => handleShowW(index)}
                                />
                              </div>
                            ))}
                          </Form>

                          {wShow === index && (
                            <Modal
                              show={true}
                              onHide={handleCloseW}
                              centered
                              className="custom-gropmodelwel roundedambdmodl"
                              backdrop={true}
                            >
                              <Modal.Header className=" border-0">
                                <img
                                  className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                  src={require("../components/image/close.png")}
                                  alt="logo"
                                  onClick={handleCloseW}
                                />
                              </Modal.Header>
                              <Modal.Title className="mx-5 "></Modal.Title>
                              <Modal.Body className="mx-4 mt-sm-2">
                                <div
                                  className=" fw-bold   text-center  w-100 ftzcopy   "
                                  style={{ fontSize: "21px" }}
                                >
                                  Are you sure that you no longer want to attend
                                  this event? The event will be removed from
                                  your dashboard.
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                  <button
                                    className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                    style={{
                                      width: "150px",
                                      height: "44px",
                                      backgroundColor: "#62C0C7",
                                    }}
                                    onClick={() => handleNotGoing1(index)}
                                  >
                                    {/* Not going */}
                                    {lg?.ngoing}
                                  </button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          )}
                        </div>
                        {/* )} */}
                        <div
                          className="fw600 text-decoration-underline"
                          style={{ fontSize: "13px", cursor: "pointer" }}
                          onClick={handleCancel1}
                        >
                          {/* Cancel */}
                          {lg?.cancel}
                        </div>
                      </div>
                    </div>

                    {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                  </Card.Body>
                </div>
              </Card>
            );
          })}
        </div>
        {/* coursol */}
        <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
          {booksilentBooks?.length === 0 && "No events to be shown."}
          <Slider {...settings}>
            {booksilentBooks.map((book, index) => {
              let spotsLeft =
                Number(book?.maxAttendee) -
                Number(book?.attendees?.length || 0);

              return (
                <div key={book._id} className="d-flex justify-content-center">
                  <Card
                    key={book._id}
                    className="border-0 align-items-center"
                    style={{ width: "" }}
                  >
                    <div className="d-sm-flex gap-2">
                      {book.image ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="wrw"
                            variant="top"
                            src={resolveBookImageUrl(book.image)}
                            style={{
                              width: "115px",
                              height: "150px",
                              objectFit: "contain",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Book Club"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                attendees: book?.attendees,
                                aboutBook: book.aboutBook,

                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 && book?.name == "Book Club" && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform:
                                  "translate(-50%, -50%) rotate(301deg)",
                                color: "red",
                                fontSize: "32px",
                                fontWeight: "bold",
                                border: "2px solid red",
                                padding: "5px 15px",
                                textTransform: "uppercase",
                                backgroundColor: "rgba(255,255,255,0.6)",
                                pointerEvents: "none",
                              }}
                            >
                              FULL
                            </div>
                          )}
                        </div>
                      ) : book.name === "Silent Reading" ? (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Card.Img
                            className="ww"
                            variant="top"
                            src={require("./image/book7.jpg")}
                            style={{
                              width: "115px",
                              height: "150px",
                              objectFit: "contain",
                              cursor: "pointer",
                              opacity:
                                book?.name == "Silent Reading"
                                  ? spotsLeft === 0
                                    ? 0.3
                                    : 1
                                  : 1,
                            }}
                            onClick={() => {
                              const eventData = {
                                type: book.name,
                                location: book.city || "", // Use dynamic location
                                link: book.link || "",
                                title: book.title,
                                image: book.image,
                                author: book.author,
                                pages: book.pageNumber,
                                genre: book.genre,
                                age: book.age,
                                city: book.city,
                                language: book.language,
                                gender: book.gender,
                                detail: book.description,
                                eventType: book.type,
                                createdAt: book?.dateInfo,
                                time: book?.timeTrack,
                                userId: book?.userId,
                                meetingLink: book?.meetingLink,
                                eventId: book._id,
                                aboutBook: book.aboutBook,

                                attendees: book?.attendees,
                                LangLat: book?.location,
                                // type:
                                //   book.type.toLowerCase() === "on-line"
                                //     ? "Book Duo"
                                //     : "Book Club", // ✅ Condition Added
                              };
                              console.log("✅ Event Data:", eventData);
                              localStorage.setItem(
                                "eventDataNew",
                                JSON.stringify(eventData)
                              );
                              handleEventTypeClick(book.name, book._id);
                            }}
                          />
                          {spotsLeft === 0 &&
                            book?.name == "Silent Reading" && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform:
                                    "translate(-50%, -50%) rotate(301deg)",
                                  color: "red",
                                  fontSize: "32px",
                                  fontWeight: "bold",
                                  border: "2px solid red",
                                  padding: "5px 15px",
                                  textTransform: "uppercase",
                                  backgroundColor: "rgba(255,255,255,0.6)",
                                  pointerEvents: "none",
                                }}
                              >
                                FULL
                              </div>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "115px",
                            height: "150px",
                            backgroundColor: "#e0e0e0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#777",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            const eventData = {
                              type: book.name,
                              location: book.city || "", // Use dynamic location
                              link: book.link || "",
                              title: book.title,
                              image: book.image,
                              author: book.author,
                              pages: book.pageNumber,
                              genre: book.genre,
                              age: book.age,
                              city: book.city,
                              language: book.language,
                              gender: book.gender,
                              detail: book.description,
                              eventType: book.type,
                              createdAt: book?.dateInfo,
                              time: book?.timeTrack,
                              userId: book?.userId,
                              meetingLink: book?.meetingLink,
                              eventId: book._id,
                              attendees: book?.attendees,
                              aboutBook: book.aboutBook,

                              LangLat: book?.location,
                              // type:
                              //   book.type.toLowerCase() === "on-line"
                              //     ? "Book Duo"
                              //     : "Book Club", // ✅ Condition Added
                            };
                            console.log("✅ Event Data:", eventData);
                            localStorage.setItem(
                              "eventDataNew",
                              JSON.stringify(eventData)
                            );
                            handleEventTypeClick(book.name, book._id);
                          }}
                        >
                          No Image
                        </div>
                      )}
                      <Card.Body className="mt-0 p-0 text-center">
                        <Card.Title
                          className=" w-100 text-blakkck  fw-bold ftztfitle "
                          style={{
                            // color: "#6D6D6D",
                            fontSize: "15px",
                            maxWidth: "115px",

                            lineHeight:
                              book.title[0] === "Before the coffee"
                                ? "20px"
                                : "25px", // Conditional line height

                            marginBottom:
                              book.title[0] === "We Solve Murders with love"
                                ? "5px"
                                : "5px", // Conditional line height
                          }}
                        >
                          {book?.name === "Silent Reading"
                            ? "Your Own Book"
                            : book?.title?.slice(0, 10) || "Normal People"}
                        </Card.Title>
                        <Card.Text
                          className=" w-100 ftzgegrn fw-bold  m-0"
                          style={{
                            // color: "#383838",
                            color: "gray",
                            fontSize: "14px",
                            lineHeight: "20px",
                            maxWidth: "130px",
                          }}
                        >
                          {book?.name == "Book Duo"
                            ? "TBD"
                            : book?.dateInfo?.dayName +
                              ",  " +
                              book?.dateInfo?.day +
                              " " +
                              book?.dateInfo?.month +
                              " " +
                              book?.dateInfo?.year}
                        </Card.Text>
                        <Card.Title
                          className=" ftzgegrn fw600  m-0"
                          style={{
                            fontSize: "15px",
                            color:
                              book.name === "Book Duo"
                                ? "#C55A11"
                                : book.name === "Book Club"
                                ? "#548235"
                                : book.name === "Silent Reading"
                                ? "#0070C0" // Blue for "Silent Reading"
                                : "#000000", // Default color for other event types

                            lineHeight: "25px",
                          }}
                        >
                          {book?.name}
                        </Card.Title>
                        <Card.Title
                          className=" ftzggern fw600  m-0"
                          style={{
                            fontSize: "15px",

                            lineHeight: "25px",
                          }}
                        >
                          Age {book.age}
                        </Card.Title>
                        {/* <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                        <div key={index}>
                          <button
                            className="rounded-1 mt-2 py-1 ediftbtitn fw600 ftzgern fs-6 text-center text-dark"
                            style={{
                              border: "1px solid #383838",
                              backgroundColor: "#F2F2F2",
                              width: "120px",
                              height: "auto",
                            }}
                            onClick={() => {
                              console.log("Clicked Not Going for", book._id);
                              setWShowCanc(true); // Show the cancel modal
                              setBookSelected(book._id); // Store the book ID for later use
                            }}
                          >
                            {/* Edit */}
                            {lg?.canc}
                          </button>

                          {/* Conditional Content */}
                          <div
                            key={index}
                            className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                              visibleCard1 === index ? "" : "d-none"
                            }`}
                            style={{
                              border: "1px solid #C1C1C1",
                              width: "240px",
                              height: "100px",
                            }}
                          >
                            <div>
                              <Form>
                                {["radio"].map((type) => (
                                  <div
                                    key={`inline-${type}`}
                                    className="fw-normal flxder   pt-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <Form.Check
                                      inline
                                      label={lg?.going}
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-1-${index}`}
                                      onClick={handlegoing1}
                                      checked={selectedGoing[index] === "Going"}
                                      onChange={() =>
                                        handleOptionChangeGoing(index, "Going")
                                      }
                                    />
                                    <Form.Check
                                      inline
                                      label={lg?.ngoing}
                                      name={`group-${index}`}
                                      type={type}
                                      id={`inline-${type}-2-${index}`}
                                      onClick={() => handleShowW(index)}
                                    />
                                  </div>
                                ))}
                              </Form>

                              {wShow === index && (
                                <Modal
                                  show={true}
                                  onHide={handleCloseW}
                                  centered
                                  className="custom-gropmodelwel roundedambdmodl"
                                  backdrop={true}
                                >
                                  <Modal.Header className=" border-0">
                                    <img
                                      className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                      src={require("../components/image/close.png")}
                                      alt="logo"
                                      onClick={handleCloseW}
                                    />
                                  </Modal.Header>
                                  <Modal.Title className="mx-5 "></Modal.Title>
                                  <Modal.Body className="mx-4 mt-sm-2">
                                    <div
                                      className=" fw-bold   text-center  w-100 ftzcopy   "
                                      style={{ fontSize: "21px" }}
                                    >
                                      Are you sure that you no longer want to
                                      attend this event? The event will be
                                      removed from your dashboard.
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                      <button
                                        className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                        style={{
                                          width: "150px",
                                          height: "44px",
                                          backgroundColor: "#62C0C7",
                                        }}
                                        onClick={() => handleNotGoing1(index)}
                                      >
                                        {/* Not going */}
                                        {lg?.ngoing}
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              )}
                            </div>
                            {/* )} */}
                            <div
                              className="fw600 text-decoration-underline"
                              style={{ fontSize: "13px", cursor: "pointer" }}
                              onClick={handleCancel1}
                            >
                              {/* Cancel */}
                              {lg?.cancel}
                            </div>
                          </div>
                        </div>

                        {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                      </Card.Body>
                    </div>
                  </Card>
                </div>
              );
            })}
          </Slider>
        </div>

        <div className=" mlmrleading textczoom11 fontupcon fw-bold mt-5 fs-5">
          {/* Upcoming Book Duo */}
          {lg?.upcomduo}
        </div>

        <div className="d-sm-flex d-none justzomag11 flex-wrap juddcfyy paddleft  mx-5 gap-3 mt-3">
          {bookDuoBooks?.length === 0 && "No events to be shown."}
          {bookDuoBooks.map((book, index) => (
            <Card
              key={book._id}
              className="border-0 align-items-center"
              style={{ width: "" }}
            >
              <div className="d-sm-flex gap-2">
                {book.image ? (
                  <Card.Img
                    className="imgsize157"
                    variant="top"
                    src={BASE_URL + book.image}
                    style={{
                      width: "119px",
                      height: "170px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        pages: book.pageNumber,
                        genre: book.genre,
                        age: book.age,
                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        meetingLink: book?.meetingLink,
                        eventId: book._id,
                        attendees: book?.attendees,
                        aboutBook: book.aboutBook,

                        LangLat: book?.location,
                        // type:
                        //   book.type.toLowerCase() === "on-line"
                        //     ? "Book Duo"
                        //     : "Book Club", // ✅ Condition Added
                      };
                      console.log("✅ Event Data:", eventData);
                      localStorage.setItem(
                        "eventDataNew",
                        JSON.stringify(eventData)
                      );
                      handleEventTypeClick(book.name, book._id);
                    }}
                  />
                ) : book.name === "Silent Reading" ? (
                  <Card.Img
                    className="imgsize157"
                    variant="top"
                    src={require("./image/book7.jpg")}
                    style={{
                      width: "119px",
                      height: "170px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        pages: book.pageNumber,
                        genre: book.genre,
                        age: book.age,
                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        meetingLink: book?.meetingLink,
                        eventId: book._id,
                        aboutBook: book.aboutBook,

                        attendees: book?.attendees,
                        LangLat: book?.location,
                        // type:
                        //   book.type.toLowerCase() === "on-line"
                        //     ? "Book Duo"
                        //     : "Book Club", // ✅ Condition Added
                      };
                      console.log("✅ Event Data:", eventData);
                      localStorage.setItem(
                        "eventDataNew",
                        JSON.stringify(eventData)
                      );
                      handleEventTypeClick(book.name, book._id);
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "119px",
                      height: "170px",
                      backgroundColor: "#e0e0e0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#777",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const eventData = {
                        type: book.name,
                        location: book.city || "", // Use dynamic location
                        link: book.link || "",
                        title: book.title,
                        image: book.image,
                        author: book.author,
                        pages: book.pageNumber,
                        genre: book.genre,
                        age: book.age,
                        city: book.city,
                        language: book.language,
                        gender: book.gender,
                        detail: book.description,
                        eventType: book.type,
                        createdAt: book?.dateInfo,
                        time: book?.timeTrack,
                        userId: book?.userId,
                        meetingLink: book?.meetingLink,
                        aboutBook: book.aboutBook,

                        eventId: book._id,
                        attendees: book?.attendees,
                        LangLat: book?.location,
                        // type:
                        //   book.type.toLowerCase() === "on-line"
                        //     ? "Book Duo"
                        //     : "Book Club", // ✅ Condition Added
                      };
                      console.log("✅ Event Data:", eventData);
                      localStorage.setItem(
                        "eventDataNew",
                        JSON.stringify(eventData)
                      );
                      handleEventTypeClick(book.name, book._id);
                    }}
                  >
                    No Image
                  </div>
                )}
                <Card.Body className="mt-0 pt-0 ">
                  <Card.Title
                    className=" w-100 text-black  fw-bold ftztitle "
                    style={{
                      // color: "#6D6D6D",
                      fontSize: "20px",
                      maxWidth: "210px",

                      lineHeight:
                        book.title[0] === "Before the coffee" ? "20px" : "25px", // Conditional line height

                      marginBottom:
                        book.title[0] === "We Solve Murders with love"
                          ? "5px"
                          : "28px", // Conditional line height
                    }}
                  >
                    {/* {book?.title ? book.title.slice(0, 14) : "Normal People"} */}
                    {book?.name === "Silent Reading"
                      ? "Your Own Book"
                      : book?.title?.slice(0, 14) || "Normal People"}
                  </Card.Title>
                  <Card.Text
                    className=" w-100 ftzgern fw-bold  m-0"
                    style={{
                      // color: "#383838",
                      color: "gray",
                      fontSize: "16px",
                      lineHeight: "25px",
                      maxWidth: "215px",
                    }}
                  >
                    {book?.name == "Book Duo"
                      ? "TBD"
                      : book?.dateInfo?.dayName +
                        ",  " +
                        book?.dateInfo?.day +
                        " " +
                        book?.dateInfo?.month +
                        " " +
                        book?.dateInfo?.year}
                  </Card.Text>
                  <Card.Title
                    className=" ftzgern fw600 fs-6 m-0"
                    style={{
                      color:
                        book.name === "Book Duo"
                          ? "#C55A11"
                          : book.name === "Book Club"
                          ? "#548235"
                          : book.name === "Silent Reading"
                          ? "#0070C0" // Blue for "Silent Reading"
                          : "#000000", // Default color for other event types

                      lineHeight: "25px",
                    }}
                  >
                    {book?.name}
                  </Card.Title>
                  <Card.Title
                    className=" ftzgern fw600 fs-6 m-0"
                    style={{
                      color: "#000000",

                      lineHeight: "25px",
                    }}
                  >
                    Age: {book?.age}
                  </Card.Title>

                  <div key={index}>
                    <button
                      className="rounded-1 mt-1 py-1 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                      style={{
                        border: "1px solid #383838",
                        backgroundColor: "#F2F2F2",
                        width: "120px",
                        height: "auto",
                      }}
                      onClick={() => {
                        console.log("Clicked Not Going for", book._id);
                        setWShowCanc(true); // Show the cancel modal
                        setBookSelected(book._id); // Store the book ID for later use
                      }}
                    >
                      {/* Edit */}
                      {lg?.canc}
                    </button>

                    {/* Conditional Content */}
                    <div
                      key={index}
                      className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                        visibleCard2 === index ? "" : "d-none"
                      }`}
                      style={{
                        border: "1px solid #C1C1C1",
                        width: "240px",
                        height: "100px",
                      }}
                    >
                      <div>
                        {/* <div className="fw-bold fs-6">
                          IF ORGANIZED BY OTHER USER
                        </div> */}
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder   pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label={lg?.going}
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-1-${index}`}
                                onClick={handlegoing2}
                                checked={selectedGoing[index] === "Going"}
                                onChange={() =>
                                  handleOptionChangeGoing(index, "Going")
                                }
                              />
                              <Form.Check
                                inline
                                label={lg?.ngoing}
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-2-${index}`}
                                onClick={() => handleShowW(index)}
                              />
                            </div>
                          ))}
                        </Form>

                        {wShow === index && (
                          <Modal
                            show={true}
                            onHide={handleCloseW}
                            centered
                            className="custom-gropmodelwel roundedambdmodl"
                            backdrop={true}
                          >
                            <Modal.Header className=" border-0">
                              <img
                                className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                src={require("../components/image/close.png")}
                                alt="logo"
                                onClick={handleCloseW}
                              />
                            </Modal.Header>
                            <Modal.Title className="mx-5 "></Modal.Title>
                            <Modal.Body className="mx-4 mt-sm-2">
                              <div
                                className=" fw-bold   text-center  w-100 ftzcopy   "
                                style={{ fontSize: "21px" }}
                              >
                                Are you sure that you no longer want to attend
                                this event? The event will be removed from your
                                dashboard.
                              </div>
                              <div className="d-flex justify-content-center mt-4">
                                <button
                                  className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                  style={{
                                    width: "150px",
                                    height: "44px",
                                    backgroundColor: "#62C0C7",
                                  }}
                                  onClick={() => handleNotGoing2(index)}
                                >
                                  {/* Not going */}
                                  {lg?.ngoing}
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        )}
                      </div>
                      {/* )} */}
                      <div
                        className="fw600 text-decoration-underline"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={handleCancel2}
                      >
                        {/* Cancel */}
                        {lg?.cancel}
                      </div>
                    </div>
                  </div>

                  {/* <div>
                  <button
                    className=" editbtitn  text-decoration-underline bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}
                </Card.Body>
              </div>
            </Card>
          ))}
        </div>
        {/* cursol */}
        <div className=" my-4 jucfyy mx-0 d-sm-none d-block  ">
          {bookDuoBooks?.length === 0 && "No events to be shown."}
          <Slider {...settings}>
            {bookDuoBooks.map((book, index) => (
              <div key={book._id} className="d-flex justify-content-center">
                <Card
                  key={book._id}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <div className="d-sm-flex gap-2">
                    {book.image ? (
                      <Card.Img
                        className="wrw"
                        variant="top"
                        src={resolveBookImageUrl(book.image)}
                        style={{
                          width: "115px",
                          height: "150px",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            aboutBook: book.aboutBook,

                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                    ) : book.name === "Silent Reading" ? (
                      <Card.Img
                        className="ww"
                        variant="top"
                        src={require("./image/book7.jpg")}
                        style={{
                          width: "115px",
                          height: "150px",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            aboutBook: book.aboutBook,

                            eventId: book._id,
                            attendees: book?.attendees,
                            LangLat: book?.location,
                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "115px",
                          height: "150px",
                          backgroundColor: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#777",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const eventData = {
                            type: book.name,
                            location: book.city || "", // Use dynamic location
                            link: book.link || "",
                            title: book.title,
                            image: book.image,
                            author: book.author,
                            pages: book.pageNumber,
                            genre: book.genre,
                            age: book.age,
                            city: book.city,
                            language: book.language,
                            gender: book.gender,
                            detail: book.description,
                            eventType: book.type,
                            createdAt: book?.dateInfo,
                            time: book?.timeTrack,
                            userId: book?.userId,
                            meetingLink: book?.meetingLink,
                            eventId: book._id,
                            attendees: book?.attendees,
                            aboutBook: book.aboutBook,

                            LangLat: book?.location,
                            // type:
                            //   book.type.toLowerCase() === "on-line"
                            //     ? "Book Duo"
                            //     : "Book Club", // ✅ Condition Added
                          };
                          console.log("✅ Event Data:", eventData);
                          localStorage.setItem(
                            "eventDataNew",
                            JSON.stringify(eventData)
                          );
                          handleEventTypeClick(book.name, book._id);
                        }}
                      >
                        No Image
                      </div>
                    )}
                    <Card.Body className="mt-0 p-0 text-center">
                      <Card.Title
                        className=" w-100 text-blakkck  fw-bold ftztfitle "
                        style={{
                          // color: "#6D6D6D",
                          fontSize: "15px",
                          maxWidth: "115px",

                          lineHeight:
                            book.title[0] === "Before the coffee"
                              ? "20px"
                              : "25px", // Conditional line height

                          marginBottom:
                            book.title[0] === "We Solve Murders with love"
                              ? "5px"
                              : "5px", // Conditional line height
                        }}
                      >
                        {book?.name === "Silent Reading"
                          ? "Your Own Book"
                          : book?.title?.slice(0, 10) || "Normal People"}
                      </Card.Title>
                      <Card.Text
                        className=" w-100 ftzgegrn fw-bold  m-0"
                        style={{
                          // color: "#383838",
                          color: "gray",
                          fontSize: "14px",
                          lineHeight: "20px",
                          maxWidth: "130px",
                        }}
                      >
                        {book?.name == "Book Duo"
                          ? "TBD"
                          : book?.dateInfo?.dayName +
                            ",  " +
                            book?.dateInfo?.day +
                            " " +
                            book?.dateInfo?.month +
                            " " +
                            book?.dateInfo?.year}
                      </Card.Text>
                      <Card.Title
                        className=" ftzgegrn fw600  m-0"
                        style={{
                          fontSize: "15px",
                          color:
                            book.name === "Book Duo"
                              ? "#C55A11"
                              : book.name === "Book Club"
                              ? "#548235"
                              : book.name === "Silent Reading"
                              ? "#0070C0" // Blue for "Silent Reading"
                              : "#000000", // Default color for other event types

                          lineHeight: "25px",
                        }}
                      >
                        {book?.name}
                      </Card.Title>
                      <Card.Title
                        className=" ftzggern fw600  m-0"
                        style={{
                          fontSize: "15px",

                          lineHeight: "25px",
                        }}
                      >
                        Age {book.age}
                      </Card.Title>
                      {/* <div>
                  <button
                    className="rounded-1 mt-1 editbtitn fw600 ftzgern fs-5 text-center text-dark"
                    style={{
                      border: "1px solid #383838",
                      backgroundColor: "#F2F2F2",
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Edit
                  </button>
                </div> */}

                      <div key={index}>
                        <button
                          className="rounded-1 mt-2 py-1 ediftbtitn fw600 ftzgern fs-6 text-center text-dark"
                          style={{
                            border: "1px solid #383838",
                            backgroundColor: "#F2F2F2",
                            width: "120px",
                            height: "auto",
                          }}
                          onClick={() => {
                            console.log("Clicked Not Going for", book._id);
                            setWShowCanc(true); // Show the cancel modal
                            setBookSelected(book._id); // Store the book ID for later use
                          }}
                        >
                          {/* Edit */}
                          {lg?.canc}
                        </button>

                        {/* Conditional Content */}
                        <div
                          key={index}
                          className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                            visibleCard2 === index ? "" : "d-none"
                          }`}
                          style={{
                            border: "1px solid #C1C1C1",
                            width: "240px",
                            height: "100px",
                          }}
                        >
                          <div>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className="fw-normal flxder   pt-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  <Form.Check
                                    inline
                                    label={lg?.going}
                                    name={`group-${index}`}
                                    type={type}
                                    id={`inline-${type}-1-${index}`}
                                    onClick={handlegoing2}
                                    checked={selectedGoing[index] === "Going"}
                                    onChange={() =>
                                      handleOptionChangeGoing(index, "Going")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    label={lg?.ngoing}
                                    name={`group-${index}`}
                                    type={type}
                                    id={`inline-${type}-2-${index}`}
                                    onClick={() => handleShowW(index)}
                                  />
                                </div>
                              ))}
                            </Form>

                            {wShow === index && (
                              <Modal
                                show={true}
                                onHide={handleCloseW}
                                centered
                                className="custom-gropmodelwel roundedambdmodl"
                                backdrop={true}
                              >
                                <Modal.Header className=" border-0">
                                  <img
                                    className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                    src={require("../components/image/close.png")}
                                    alt="logo"
                                    onClick={handleCloseW}
                                  />
                                </Modal.Header>
                                <Modal.Title className="mx-5 "></Modal.Title>
                                <Modal.Body className="mx-4 mt-sm-2">
                                  <div
                                    className=" fw-bold   text-center  w-100 ftzcopy   "
                                    style={{ fontSize: "21px" }}
                                  >
                                    Are you sure that you no longer want to
                                    attend this event? The event will be removed
                                    from your dashboard.
                                  </div>
                                  <div className="d-flex justify-content-center mt-4">
                                    <button
                                      className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                      style={{
                                        width: "150px",
                                        height: "44px",
                                        backgroundColor: "#62C0C7",
                                      }}
                                      onClick={() => handleNotGoing2(index)}
                                    >
                                      {/* Not going */}
                                      {lg?.ngoing}
                                    </button>
                                  </div>
                                </Modal.Body>
                              </Modal>
                            )}
                          </div>
                          {/* )} */}
                          <div
                            className="fw600 text-decoration-underline"
                            style={{ fontSize: "13px", cursor: "pointer" }}
                            onClick={handleCancel1}
                          >
                            {/* Cancel */}
                            {lg?.cancel}
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </div>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
        <div className="d-fddlex d-none justzomag11 flex-wrap jucffffyy paddleft  mx-sm-5 mx-3 gap-3 mt-3">
          {books1.map((book, index) => (
            <Card
              key={index}
              className="border-0 align-items-center"
              style={{ width: "" }}
            >
              <div className="d-sm-flex gap-2">
                <Card.Img
                  className="imgsffize"
                  variant="top"
                  src={book.image}
                  style={{ width: "119px", height: "170px", cursor: "pointer" }}
                  onClick={() => handleEventTypeClick(book.eventType)}
                />
                <Card.Body className="mt-0 pt-0 ">
                  <Card.Title
                    className=" w-100 text-black  fw-bold ftztfffitle "
                    style={{
                      // color: "#6D6D6D",
                      fontSize: "16px",
                      maxWidth: "180px",

                      lineHeight:
                        book.title[0] === "Before the coffee" ? "20px" : "25px", // Conditional line height

                      marginBottom:
                        book.title[0] === "We Solve Murders with love"
                          ? "5px"
                          : "5px", // Conditional line height
                    }}
                  >
                    {book.title[0]} <br /> {book.title[1]}
                  </Card.Title>
                  <Card.Text
                    className=" w-100 ftffzgern fw-bold  m-0"
                    style={{
                      // color: "#383838",
                      color: "gray",
                      fontSize: "15px",
                      lineHeight: "25px",
                      maxWidth: "190px",
                    }}
                  >
                    {book.eventDate}
                  </Card.Text>
                  <Card.Title
                    className=" ftzgerffn fw600  m-0"
                    style={{
                      color:
                        book.eventType === "Book Duo"
                          ? "#C55A11"
                          : book.eventType === "Book Club"
                          ? "#548235"
                          : book.eventType === "Silent Reading"
                          ? "#0070C0" // Blue for "Silent Reading"
                          : "#000000", // Default color for other event types

                      lineHeight: "25px",
                      fontSize: "15px",
                    }}
                  >
                    {book.eventType}
                  </Card.Title>
                  <Card.Title
                    className=" ftzgeddrn fw600  m-0"
                    style={{
                      color: "#000000",

                      lineHeight: "25px",
                      fontSize: "15px",
                    }}
                  >
                    {book.ageGroup}
                  </Card.Title>

                  <div key={index}>
                    <button
                      className="rounded-1 mt-2 py-1 px-3 editbtitn fw600 ftzgern fs-6 text-center text-dark"
                      style={{
                        border: "1px solid #383838",
                        backgroundColor: "#F2F2F2",
                        width: "",
                        height: "auto",
                      }}
                      onClick={() => handleEditClick2(index)}
                    >
                      {/* Edit */}
                      {lg?.canc}
                    </button>

                    {/* Conditional Content */}
                    <div
                      key={index}
                      className={`z-3 mt-2 p-2 oraginwid bg-white position-absolute ${
                        visibleCard2 === index ? "" : "d-none"
                      }`}
                      style={{
                        border: "1px solid #C1C1C1",
                        width: "240px",
                        height: "100px",
                      }}
                    >
                      {/* {index === 1 ? (
                      // <div>
                      //   <div className="fw-bold fs-6">IF ORGANIZED BY USER</div>
                      //   <Form>
                      //     {["radio"].map((type) => (
                      //       <div
                      //         key={`inline-${type}-second`}
                      //         className="fw-normal flxder"
                      //         style={{ fontSize: "14px" }}
                      //       >
                      //         <Form.Check
                      //           inline
                      //           label="Confirm"
                      //           name={`group-second`}
                      //           type={type}
                      //           id={`inline-${type}-1-second`}
                      //         />
                      //         <Form.Check
                      //           inline
                      //           label="Reject"
                      //           name={`group-second`}
                      //           type={type}
                      //           id={`inline-${type}-2-second`}
                      //         />
                      //         <Form.Check
                      //           inline
                      //           label="Edit"
                      //           name={`group-second`}
                      //           type={type}
                      //           id={`inline-${type}-3-second`}
                      //         />
                      //       </div>
                      //     ))}
                      //   </Form>
                      // </div>

                      <div>
                       
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder  pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-5-${index}`}
                                onClick={handlegoing2}
                                checked={selectedGoing2[index] === "Going"}
                                onChange={() =>
                                  handleOptionChangeGoing2(index, "Going")
                                }
                              />
                              <Form.Check
                                inline
                                label="not going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-6-${index}`}
                                onChange={() => handleNotGoing2(index)}
                              />
                            </div>
                          ))}
                        </Form>
                      </div>
                    ) : ( */}
                      <div>
                        {/* //   <div className="fw-bold fs-6">
                      //     IF ORGANIZED BY OTHER USER
                      //   </div> */}
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder pt-1"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-5-${index}`}
                                onClick={handlegoing2}
                                checked={selectedGoing2[index] === "Going"}
                                onChange={() =>
                                  handleOptionChangeGoing2(index, "Going")
                                }
                              />
                              <Form.Check
                                inline
                                label="not going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-6-${index}`}
                                onChange={() => handleShowW2(index)}
                              />
                            </div>
                          ))}
                        </Form>

                        {wShow2 === index && (
                          <Modal
                            show={true}
                            onHide={handleCloseW2}
                            centered
                            className="custom-gropmodelwel roundedambdmodl"
                            backdrop={true}
                          >
                            <Modal.Header className=" border-0">
                              <img
                                className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
                                src={require("../components/image/close.png")}
                                alt="logo"
                                onClick={handleCloseW2}
                              />
                            </Modal.Header>
                            <Modal.Title className="mx-5 "></Modal.Title>
                            <Modal.Body className="mx-4 mt-sm-2">
                              <div
                                className=" fw-bold   text-center  w-100 ftzcopy   "
                                style={{ fontSize: "21px" }}
                              >
                                Are you sure that you no longer want to attend
                                this event? The event will be removed from your
                                dashboard.
                              </div>
                              <div className="d-flex justify-content-center mt-4">
                                <button
                                  className="text-white subbtnmeet border-0 fs-5 fw600 rounded-2"
                                  style={{
                                    width: "150px",
                                    height: "44px",
                                    backgroundColor: "#62C0C7",
                                  }}
                                  onClick={() => handleNotGoing2(index)}
                                >
                                  Not going
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        )}
                      </div>
                      {/* )} */}
                      <div
                        className="fw600 text-decoration-underline"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                        onClick={handleCancel2}
                      >
                        Cancel
                      </div>
                    </div>
                  </div>

                  {/* <div>
                  <button
                    className=" editbtitn text-decoration-underline  bg-transparent border-0 fw600 fs-6 text-center text-dark"
                    style={{
                      width: "122px",
                      height: "42px",
                    }}
                  >
                    Cancel
                  </button>
                </div> */}

                  {/* <div
                    key={index}
                    className=" z-3 mt-2 p-2 d-none oraginwid bg-white position-absolute "
                    style={{
                      border: "1px solid #C1C1C1",
                      width: "277px",
                      height: "130px",
                    }}
                  >
                    //  Conditional check to change the content of the second card
                    {index === 1 ? (
                      <div>
                        <div className="fw-bold fs-6">IF ORGANIZED BY USER</div>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}-second`}
                              className="fw-normal flxder"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="confirm"
                                name={`group-second`}
                                type={type}
                                id={`inline-${type}-1-second`}
                              />
                              <Form.Check
                                inline
                                label="Reject"
                                name={`group-second`}
                                type={type}
                                id={`inline-${type}-2-second`}
                              />
                              <Form.Check
                                inline
                                label="Edit"
                                name={`group-second`}
                                type={type}
                                id={`inline-${type}-3-second`}
                              />
                            </div>
                          ))}
                        </Form>
                      </div>
                    ) : (
                      <div>
                        <div className="fw-bold fs-6">
                          IF ORGANIZED BY OTHER USER
                        </div>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className="fw-normal flxder"
                              style={{ fontSize: "14px" }}
                            >
                              <Form.Check
                                inline
                                label="going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-1-${index}`}
                              />
                              <Form.Check
                                inline
                                label="not going"
                                name={`group-${index}`}
                                type={type}
                                id={`inline-${type}-2-${index}`}
                              />
                            </div>
                          ))}
                        </Form>
                      </div>
                    )}
  
                    <div className="fw600  text-decoration-underline" style={{ fontSize: "13px" }}>
                      Cancel
                    </div>
                  </div> */}
                </Card.Body>
              </div>
            </Card>
          ))}
        </div>

        <div className=" mlmrleading d-none textczoom11 fontupcon fw-bold mt-5 fs-5">
          {/* All past events */}
          {lg?.allpst}
        </div>

        <div className="d-sm-flssex d-none justzomag11 flex-wrap jucfyy paddleft mx-5 gap-3 mt-3">
          {bookspst.map((book, index) => (
            <Card
              key={index}
              className="border-0 align-items-center"
              style={{ width: "" }}
            >
              <div className="d-sm-flex gap-2">
                <Card.Img
                  className="imgsize1111"
                  variant="top"
                  src={book.image}
                  style={{ width: "119px", height: "170px", cursor: "pointer" }}
                  onClick={() => handleEventTypeClick(book.eventType)}
                />
                <Card.Body className="mt-1 ">
                  <Card.Title
                    className=" w-100 text-black  fw-bold ftztitle "
                    style={{
                      // color: "#6D6D6D",
                      fontSize: "20px",
                      maxWidth: "210px",

                      lineHeight:
                        book.title[0] === "Before the coffee" ? "20px" : "25px", // Conditional line height

                      marginBottom:
                        book.title[0] === "We Solve Murders with love"
                          ? "5px"
                          : "15px", // Conditional line height
                    }}
                  >
                    {book.title[0]} <br /> {book.title[1]}
                  </Card.Title>
                  <Card.Text
                    className=" w-100 ftzgern fw-bold  m-0"
                    style={{
                      // color: "#383838",
                      color: "gray",
                      fontSize: "16px",
                      lineHeight: "25px",
                      maxWidth: "215px",
                    }}
                  >
                    {book.eventDate}
                  </Card.Text>
                  <Card.Title
                    className=" ftzgern fw600 fs-6 m-0"
                    style={{
                      color:
                        book.eventType === "Book Duo"
                          ? "#C55A11"
                          : book.eventType === "Book Club"
                          ? "#548235"
                          : book.eventType === "Silent Reading"
                          ? "#0070C0" // Blue for "Silent Reading"
                          : "#000000", // Default color for other event types

                      lineHeight: "25px",
                    }}
                  >
                    {book.eventType}
                  </Card.Title>
                  <Card.Title
                    className=" ftzgern fw600 fs-6 m-0"
                    style={{
                      color: "#000000",

                      lineHeight: "25px",
                    }}
                  >
                    {book.ageGroup}
                  </Card.Title>
                </Card.Body>
              </div>
            </Card>
          ))}
        </div>
        {/* coursol */}
        <div className=" my-4 d-none jucfyy mx-0 d-sm-none d-block  ">
          <Slider {...settings}>
            {bookspst.map((book, index) => (
              <div key={index} className="d-flex justify-content-center">
                <Card
                  key={index}
                  className="border-0 align-items-center"
                  style={{ width: "" }}
                >
                  <div className="d-sm-flex gap-2">
                    <Card.Img
                      className="imgsizffe"
                      variant="top"
                      src={book.image}
                      style={{
                        width: "110px",
                        height: "170px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEventTypeClick(book.eventType)}
                    />
                    <Card.Body className="mt-0 p-0 text-center">
                      <Card.Title
                        className=" w-100 text-blakkck  fw-bold ftztfitle "
                        style={{
                          // color: "#6D6D6D",
                          fontSize: "15px",
                          maxWidth: "115px",

                          lineHeight:
                            book.title[0] === "Before the coffee"
                              ? "20px"
                              : "25px", // Conditional line height

                          marginBottom:
                            book.title[0] === "We Solve Murders with love"
                              ? "5px"
                              : "5px", // Conditional line height
                        }}
                      >
                        {book.title[0]} <br /> {book.title[1]}
                      </Card.Title>
                      <Card.Text
                        className=" w-100 ftzgegrn fw-bold  m-0"
                        style={{
                          // color: "#383838",
                          color: "gray",
                          fontSize: "14px",
                          lineHeight: "20px",
                          maxWidth: "130px",
                        }}
                      >
                        {book.eventDate}
                      </Card.Text>
                      <Card.Title
                        className=" ftzgegrn fw600  m-0"
                        style={{
                          fontSize: "15px",
                          color:
                            book.eventType === "Book Duo"
                              ? "#C55A11"
                              : book.eventType === "Book Club"
                              ? "#548235"
                              : book.eventType === "Silent Reading"
                              ? "#0070C0" // Blue for "Silent Reading"
                              : "#000000", // Default color for other event types

                          lineHeight: "25px",
                        }}
                      >
                        {book.eventType}
                      </Card.Title>
                      <Card.Title
                        className=" ftzggern fw600  m-0"
                        style={{
                          fontSize: "15px",

                          lineHeight: "25px",
                        }}
                      >
                        {book.ageGroup}
                      </Card.Title>
                    </Card.Body>
                  </div>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className="mt-5">
        <Footer2 />
      </div>
      <Modal
        show={wShowCanc}
        onHide={handleCloseCanc}
        centered
        className="custom-gropmodelwel weldonemodel"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn24 mt-1 "
            style={{ top: "9px", right: "30px" }}
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseCanc}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold mx-sm-2 text-center  aboutauther  "
            style={{ fontSize: "24px" }}
          >
            {/* Well done! */}
            Are you sure you want to cancel your RSVP?
          </div>
        </Modal.Title>
        <Modal.Body className="mx-4 pt-0 mt-sm-3 mt-2">
          <div
            className=" fw600 mx-lg-3 text-center mt-sm-3 mt-2   w-100 ftzcopy   "
            style={{ maxWidth: "900px", fontSize: "18px" }}
          >
            A cancellation e-mail will be sent to Ambassador.
          </div>
          <div className="mt-sm-4 mt-3 text-center ">
            <button
              onClick={() => {
                handleNotGoing(bookSelected);
                setWShowCanc(false);
                //navigate(`/booksdetails/${bookSelected?._id}`);
              }}
              className="w-100 modelbtnjoin text-white ftzcopy text-center border-0 rounded-1 fw600 "
              style={{
                maxWidth: "162px ",
                fontSize: "22px",
                height: "45px",
                backgroundColor: "#34C3C9",
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DashBoardUser;
